<template>
  <div class="subscription_form">
    <form-heading title="Subscription Configuration" description="Manage subscriptions for your channel" />
    <form-inputs>

      <div class="form-input">
        <label class="form-label">
          Subscription pricing
        </label>
        <div class="form-input-main">
        <select v-model="subscriptionPricingModel" name="tenant[subscription_pricing_model]">
          <option value="free">Free — Do not charge</option>
          <option value="paid">Fixed price</option>
          <option value="pay_what_you_can">Pay what you can</option>
        </select>
        </div>
      </div>

      <div v-if="subscriptionPricingModel == 'paid'">
        <div class="form-input string">
          <label class="form-label string required" for="subscription_price">
            Price
            <abbr title="required">*</abbr>
          </label>
          <div class="form-input-main">
            <input v-model="price" name="tenant[subscription_price_form]" autofocus="autofocus" class="string price" type="text" id="subscription_price" required  :disabled="!stripeIsSetup" />
            <small>per month</small>
          </div>
        </div>

        <div class="form-input boolean" v-if="stripeFee">
          <label class="form-label">Fees</label>
          <div class="form-input-main">
            <table>
              <tr>
                <td class="pr-8"><i>Pennant:</i></td>
                <td>-$1.00</td>
              </tr>
              <tr style="border-bottom: 1px dashed #ccc;">
                <td><i>Stripe:</i></td>
                <td>-${{stripeFee}}</td>
              </tr>
              <tr>
                <td>Net:</td>
                <td>${{netPrice}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-if="subscriptionPricingModel == 'pay_what_you_can'">
        <form-heading title="Minimum Price" class="pt-12"/>

        <div class="form-input string">
          <label class="form-label string required" for="subscription_price">
            Minimum Custom Price
            <abbr title="required">*</abbr>
          </label>
          <div class="form-input-main">
            <input v-model="priceMin" name="tenant[subscription_price_min_form]" autofocus="autofocus" class="string price" type="text" id="subscription_price_min" required  :disabled="!stripeIsSetup" />
            <small>per month</small>
          </div>
        </div>

        <div class="form-input boolean" v-if="stripeFeeMin">
          <label class="form-label">Fees</label>
          <div class="form-input-main">
            <table>
              <tr>
                <td class="pr-8"><i>Pennant:</i></td>
                <td>-$1.00</td>
              </tr>
              <tr style="border-bottom: 1px dashed #ccc;">
                <td><i>Stripe:</i></td>
                <td>-${{stripeFeeMin}}</td>
              </tr>
              <tr>
                <td>Net:</td>
                <td>${{netPriceMin}}</td>
              </tr>
            </table>
          </div>
        </div>

        <form-heading title="Pricing Options" class="pt-12"/>
        <p v-if="minimumPriceError" class="pb-6 pt-6" style="color: #cc4b37"><strong>{{minimumPriceError}}</strong></p>

        <div class="form-input string">
          <label class="form-label string required" for="subscription_price">
            Default Price Option
            <abbr title="required">*</abbr>
          </label>
          <div class="form-input-main">
            <input v-model="price" name="tenant[subscription_price_form]" autofocus="autofocus" class="string price" type="text" id="subscription_price" required  :disabled="!stripeIsSetup" />
            <small>per month</small>
          </div>
        </div>

        <div class="form-input boolean" v-if="stripeFee">
          <label class="form-label">Fees</label>
          <div class="form-input-main">
            <table>
              <tr>
                <td class="pr-8"><i>Pennant:</i></td>
                <td>-$1.00</td>
              </tr>
              <tr style="border-bottom: 1px dashed #ccc;">
                <td><i>Stripe:</i></td>
                <td>-${{stripeFee}}</td>
              </tr>
              <tr>
                <td>Net:</td>
                <td>${{netPrice}}</td>
              </tr>
            </table>
          </div>
        </div>

      <div class="form-input string">
        <label class="form-label string required" for="subscription_price">
          Second Price Option
          <abbr title="required">*</abbr>
        </label>
        <div class="form-input-main">
          <input v-model="priceB" name="tenant[subscription_price_b_form]" autofocus="autofocus" class="string price" type="text" id="subscription_price_b" required  :disabled="!stripeIsSetup" />
          <small>per month</small>
        </div>
      </div>

        <div class="form-input boolean" v-if="stripeFeeC">
        <label class="form-label">Fees</label>
        <div class="form-input-main">
          <table>
            <tr>
              <td class="pr-8"><i>Pennant:</i></td>
              <td>-$1.00</td>
            </tr>
            <tr style="border-bottom: 1px dashed #ccc;">
              <td><i>Stripe:</i></td>
              <td>-${{stripeFeeB}}</td>
            </tr>
            <tr>
              <td>Net:</td>
              <td>${{netPriceB}}</td>
            </tr>
          </table>
        </div>
      </div>


      <div class="form-input string">
        <label class="form-label string required" for="subscription_price">
          Third Price Option
          <abbr title="required">*</abbr>
        </label>
        <div class="form-input-main">
          <input v-model="priceC" name="tenant[subscription_price_c_form]" autofocus="autofocus" class="string price" type="text" id="subscription_price_c" required  :disabled="!stripeIsSetup" />
          <small>per month</small>
        </div>
      </div>

      <div class="form-input boolean required">
        <label class="form-label">Fees</label>
        <div class="form-input-main">
          <table>
            <tr>
              <td class="pr-8"><i>Pennant:</i></td>
              <td>-$1.00</td>
            </tr>
            <tr style="border-bottom: 1px dashed #ccc;">
              <td><i>Stripe:</i></td>
              <td>-${{stripeFeeC}}</td>
            </tr>
            <tr>
              <td>Net:</td>
              <td>${{netPriceC}}</td>
            </tr>
          </table>
        </div>
      </div>


      </div>


    </form-inputs>

    <form-actions>
      <btn v-if="!stripeIsSetup" variant="secondary" :icon="false" tag="button" disabled="disabled" class="disabled:pointer-events-none">Save</btn>
      <btn v-if="stripeIsSetup && formValid" type="submit" :icon="false" tag="button" accesskey="s" >Save</btn>
    </form-actions>

  </div>
</template>

<script>
export default {
  props: {
    stripeIsSetup: Boolean,
    initSubscriptionPricingModel: String,
    initSubscriptionPriceForm: String,
    initSubscriptionPriceBForm: String,
    initSubscriptionPriceCForm: String,
    initSubscriptionPriceMinForm: String,
    stripeFee: String,
    netPrice: String,
    stripeFeeB: String,
    netPriceB: String,
    stripeFeeC: String,
    netPriceC: String,
    stripeFeeMin: String,
    netPriceMin: String,
  },
  data() {
    return {
      subscriptionPricingModel: this.initSubscriptionPricingModel,
      price: this.initSubscriptionPriceForm || '',
      priceB: this.initSubscriptionPriceBForm || '',
      priceC: this.initSubscriptionPriceCForm || '',
      priceMin: this.initSubscriptionPriceMinForm || '',
      errors: null,
      showFlash: false,
      showGeneralError: false,
      isSubmitting: false,
      minimumPriceError: null
    }
  },
  mounted() {
  },
  computed: {
    nonZeroPrice() {
      return  false //(this.priceCurrent.length > 0 && this.priceCurrent != '0')
    },
    formValid() {
      if(this.subscriptionPricingModel !== 'pay_what_you_can') {
        return true
      }
      if(
        + this.priceMin > +this.price ||
        + this.priceMin > +this.priceB ||
        + this.priceMin > +this.priceC
      ) {
        this.minimumPriceError = this.priceMin ? 'All suggested price options should be above the minimum price.' : null
        return false
      }
      else {
        this.minimumPriceError = null
        return true
      }
    }
  },
  methods: {

  },
}
</script>
